// src/pages/HRDetail.js
import React, { useState, useEffect } from "react";
import "./HRDetail.css";
import profilePic from "../assets/girl.png";
import apiClient from "../utils/apiClient"; // global API client
import SessionHandler from "../components/SessionHandler"; // global session expiry modal

const HRDetail = () => {
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const data = await apiClient("/hrdetail/employees/");
        if (data) {
          const employees = Array.isArray(data.results) ? data.results : data;
          setEmployeeDetails(employees);
        }
      } catch (err) {
        console.error("Error fetching employee details:", err);
        setError(err.message || "Failed to fetch employee details.");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeeData();
  }, []);

  return (
    <div className="employee-container">
      <h2>HR Details</h2>

      {loading ? (
        <div className="loading">Loading...</div>
      ) : error ? (
        <div className="error">Error: {error}</div>
      ) : (
        <div className="tile-container">
          {employeeDetails.map((employee) => (
            <div className="tile" key={employee.id}>
              <div className="profile-image">
                <img
                  src={employee.profile_image || profilePic}
                  alt={employee.name}
                  className="user-avatar"
                  onError={(e) => (e.target.src = profilePic)}
                />
              </div>
              <div className="tile-info">
                <h2>{employee.name}</h2>
                <h3>{employee.email}</h3>
                <h3>Position: {employee.position}</h3>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Global Session Expiry Modal */}
      <SessionHandler />
    </div>
  );
};

export default HRDetail;
